import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@tanium/react-button';
import { Box } from '@tanium/react-box';
import { TitleBoldText } from '../../TextStyles';

export interface CreateAccountConfirmProps {
  switchToLocalSignin: () => void;
}

export const CreateAccountConfirm: React.VFC<CreateAccountConfirmProps> = ({ switchToLocalSignin }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TitleBoldText>{t('Thank you')}</TitleBoldText>
      <p>{t('A confirmation email with...')}</p>
      <Box mt={2}>
        <Button variant="link" onClick={switchToLocalSignin}>
          {t('Continue to Sign In')}
        </Button>
      </Box>
    </Box>
  );
};
